import { Component, OnInit } from '@angular/core';
import { QuickDialog } from '../utilities/Dialog/QuickDialog';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { UserService } from '../services/user-service/user.service';
import { CompanyService } from '../services/company-service/company.service';

@Component({
  selector: 'app-client-login',
  templateUrl: './client-login.component.html',
  styleUrls: ['./client-login.component.css']
})
export class ClientLoginComponent implements OnInit {

  email;
  password;

  constructor(private router: Router, private companyService: CompanyService, private dialog: MatDialog) { }

  ngOnInit() {

  }

  login() {


    this.companyService.loginUser(this.email, this.password).then((res: any) => {
      if (res.status) {
        window.localStorage.clear();
        console.log(res.data);
        window.localStorage.setItem("login", JSON.stringify(res.data));
        this.router.navigate(['client-portal']);
      } else {

        new QuickDialog(this.dialog).InfoDialog("Please ensure your email and password is correct", "Login Failed", "OK");
      }
    }).catch(e => {
      console.log(e);
      if (e.status == 401) {
        new QuickDialog(this.dialog).InfoDialog("Please ensure your email and password is correct", "Login Failed", "OK");
      } else {
        new QuickDialog(this.dialog).InfoDialog("An Error Occured Please Try Again", "Login Failed", "OK");
      }

    });
  }

}
